var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMsg),expression:"showMsg"}],staticClass:"msg"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desc"},[_c('img',{attrs:{"src":require("../../assets/img/msg.png"),"alt":""}}),_c('p',[_vm._v("\n      您目前还不是黑卡PLUS会员，无法享受会员专属优惠价格，以下商品均为原价。\n      ")])])
}]

export { render, staticRenderFns }